// import { storeToRefs } from 'pinia';
import { createRouter, createWebHashHistory } from 'vue-router';
// import NotFound from '../views/NotFound.vue';
import { useDetailStore } from '../store/index';
// import SignInView from '../views/SignIn.vue';

// const authorizeIsAdmin = (to, from, next) => {
//   const detailStore = useDetailStore();
//   const { currentUser } = storeToRefs(detailStore);
//   if (currentUser && !(currentUser.role === 'admin' || currentUser.role === 'super')) {
//     next('/not-found');
//     return;
//   }

//   next();
// };

const routes = [
  {
    path: '/',
    name: 'home',
    // component: () => import('../views/ModelView.vue'),
    // component: () => import('../views/SampleTestView.vue'),
    redirect: '/do-test',
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/lne',
    name: 'lne',
    component: () => import('../views/LneView.vue'),
  },
  {
    path: '/signin',
    name: 'sign-in',
    // component: SignInView,
    component: () => import('../views/SignIn.vue'),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: '/signup',
    name: 'sign-up',
    component: () => import('../views/SignUp.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/model-history',
    name: 'model-history',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/ModelView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/user-info',
    name: 'user-info',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/UserInfoView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/qna',
    name: 'qna',
    component: () => import('../views/QnA.vue'),
  },
  {
    path: '/add-customer',
    name: 'add-customer',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/AddCustomerView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/add-product',
    name: 'add-product',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/AddProductView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/sample-test-datasets',
    name: 'sample-test-datasets',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/SampleTestDatasetsView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/sample-test',
    name: 'sample-test',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/SampleTestView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    // for Guest  - Used
    path: '/simulation-test',
    name: 'simulation-test',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/GuestSampleTestView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    // for Guest  - Used
    path: '/do-test',
    name: 'do-test',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/DoTestView.vue'),
    // meta: {
    //   keepAlive: false,
    // },DownloadDataView
  },
  {
    path: '/do-image-test',
    name: 'do-image-test',
    component: () => import('../views/DoImageTestView.vue'),
  },
  {
    path: '/test-submission-information',
    name: 'test-submission-information',
    component: () => import('../views/TestSubmissionInformation.vue'),
  },
  {
    path: '/download-data',
    name: 'download-data',
    component: () => import('../views/DownloadDataView.vue'),
  },
  {
    path: '/tools',
    name: 'tools',
    component: () => import('../views/Tools.vue'),
  },
  {
    // for Guest - Used
    path: '/simulation-image-test',
    name: 'simulation-image-test',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/GuestImageSampleTestView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/setting-info',
    name: 'setting-info',
    component: () => import('../views/SettingView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/news-info',
    name: 'news-info',
    component: () => import('../views/NewsView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/news-list',
    name: 'news-list',
    component: () => import('../views/AllNewsList.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/testing-level',
    name: 'testing-level',
    component: () => import('../views/TestingLevel.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/IndexView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/radar-detail',
    name: 'radar-detail',
    component: () => import('../views/RadarView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/multiple-radar-detail',
    name: 'multiple-radar-detail',
    component: () => import('../views/MultipleRadarView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/single-item-report',
    name: 'single-item-report',
    // props: (route) => route.params,
    component: () => import('../views/SingleItemReportView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/sample-datasets',
    name: 'sample-datasets',
    component: () => import('../views/SampleDatasetsView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import('../views/AboutUs.vue'),
  },
  {
    path: '/TSG',
    name: 'TSG',
    component: () => import('../views/TSG.vue'),
  },
  {
    path: '/Privacy',
    name: 'Privacy',
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: '/aiec-info',
    name: 'aiec-info',
    component: () => import('../views/AiecInfoView.vue'),
  },
  {
    path: '/ai-testing-lab-info',
    name: 'ai-testing-lab-info',
    component: () => import('../views/AiTestingLabInfoView.vue'),
  },
  {
    path: '/aiec-private-info',
    name: 'aiec-private-info',
    component: () => import('../views/AiecPrivateInfoView.vue'),
  },
  {
    path: '/lne-info',
    name: 'lne-info',
    component: () => import('../views/LneInfoView.vue'),
  },
  {
    path: '/ul-info',
    name: 'ul-info',
    component: () => import('../views/UlInfoView.vue'),
  },
  {
    path: '/ai-standards-hub-info',
    name: 'ai-standards-hub-info',
    component: () => import('../views/AIStandardsHubInfoView.vue'),
  },
  {
    path: '/oecd-info',
    name: 'oecd-info',
    component: () => import('../views/OecdInfoView.vue'),
  },
  {
    path: '/european-commission-info',
    name: 'european-commission-info',
    component: () => import('../views/EuropeanCommissionInfoView.vue'),
  },
  {
    path: '/unesco-info',
    name: 'unesco-info',
    component: () => import('../views/UNESCOInfoView.vue'),
  },
  {
    path: '/nist-info',
    name: 'nist-info',
    component: () => import('../views/NistInfoView.vue'),
  },
  {
    path: '/lne-intro-info',
    name: 'lne-intro-info',
    component: () => import('../views/LneIntroInfoView.vue'),
  },
  {
    path: '/npl-intro-info',
    name: 'npl-intro-info',
    component: () => import('../views/NplIntroInfoView.vue'),
  },
  {
    path: '/naic-intro-info',
    name: 'naic-intro-info',
    component: () => import('../views/NAICIntroInfoView.vue'),
  },
  {
    path: '/ipa-intro-info',
    name: 'ipa-intro-info',
    component: () => import('../views/IPAIntroInfoView.vue'),
  },
  {
    path: '/imda-intro-info',
    name: 'imda-intro-info',
    component: () => import('../views/IMDAIntroInfoView.vue'),
  },
  {
    path: '/iso-intro-info',
    name: 'iso-intro-info',
    component: () => import('../views/ISOIntroInfoView.vue'),
  },
  {
    path: '/formal-datasets',
    name: 'formal-datasets',
    component: () => import('../views/FormalDatasetsView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/explain-result/:modelId/:testItem',
    name: 'explain-result',
    component: () => import('../views/ExplainResultView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/total-result/:modelId',
    name: 'total-result',
    component: () => import('../views/TotalResultView.vue'),
  },
  {
    path: '/news-editor',
    name: 'news-editor',
    component: () => import('../views/NewsEditor.vue'),
  },
  {
    path: '/news-detail/:newsId',
    name: 'news-detail',
    component: () => import('../views/NewsDetail.vue'),
  },
  {
    path: '/question-bank',
    name: 'QuestionBank',
    component: () => import('../views/QuestionBank.vue'),
  },
  {
    path: '/log-info',
    name: 'LogInfo',
    component: () => import('../views/LogView.vue'),
  },
  {
    path: '/zero-hallucination-llm-test',
    name: 'ZeroHallucinationLLMTest',
    component: () => import('../views/ZeroHallucinationView.vue'),
  },
  {
    path: '/device-management',
    name: 'DeviceManagement',
    component: () => import('../views/DeviceManagement.vue'),
  },
  {
    path: '/partner-info-management',
    name: 'PartnerInfoManagement',
    component: () => import('../views/PartnerInfoManagement.vue'),
  },
  {
    path: '/ai-testing-lab-info-management',
    name: 'AITestingLabInfoManagement',
    component: () => import('../views/AITestingLabInfoManagement.vue'),
  },
  {
    path: '/ai-taiwan-show',
    name: 'ai-taiwan-show',
    // props: true,
    // props: (route) => route.params,
    component: () => import('../views/AITaiwanShowView.vue'),
    // meta: {
    //   keepAlive: false,
    // },
  },
  {
    path: '/generate-chart',
    name: 'generate-chart',
    component: () => import('../views/GenerateChart.vue'),
  },
  {
    // path: '/:pathMatch(.*)*',
    // path: '/:catchAll(.*)',
    path: '/:catchAll(.*)*',
    name: 'not-found',
    // component: () => import('../views/SignIn.vue'),
    redirect: '/',
    // meta: {
    //   requiresAuth: false,
    // },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const detailStore = useDetailStore();
  let { isAuthenticated } = detailStore;

  // 如果尚未驗證，嘗試透過 cookie 向後端驗證當前用戶
  if (!isAuthenticated) {
    isAuthenticated = await detailStore.fetchCurrentUser();
  }

  // console.log(`2isAuthenticated: ${isAuthenticated}`);
  // eslint-disable-next-line max-len
  // const pathsWithoutAuthentication = ['sign-in', 'sign-up', 'sample-datasets', 'ai-taiwan-show', 'AboutUs', 'TSG', 'Privacy', 'qna', 'index'];
  const pathsWithoutAuthentication = [
    'sample-datasets',
    'ai-taiwan-show',
    'AboutUs',
    'TSG',
    'Privacy',
    'qna',
    'index',
    'testing-level',
    'qna',
    'news-editor',
    'news-detail',
    'tools',
    'news-list',
    'aiec-info',
    'lne-info',
    'ul-info',
    'ai-standards-hub-info',
    'oecd-info',
    'european-commission-info',
    'unesco-info',
    'nist-info',
    'lne-intro-info',
    'npl-intro-info',
    'naic-intro-info',
    'ipa-intro-info',
    'imda-intro-info',
    'iso-intro-info',
    'ai-testing-lab-info',
  ];

  // 如果 token 無效，且要去除了登入和註冊以外的其他頁面，則轉址到登入頁
  if (!isAuthenticated && !pathsWithoutAuthentication.includes(to.name)) {
    // console.log('11111111');
    // next('/signin');
    next('/index');
    return;
  }
  // console.log(`66666666 isAuthenticated: ${isAuthenticated}, to.name: ${to.name}`);

  // 如果 token 有效，且要去登入和註冊頁，則轉址到首頁
  // if (isAuthenticated && pathsWithoutAuthentication.includes(to.name)) {
  //   console.log('222222');
  //   next('/signup');
  //   return;
  // }

  next();
});

export default router;
